export const reduxKeyBuyer = '@@ADOPTS_BUYER';
export const i18nNamespace = 'adopts';

export enum AdoptsModalType {
  SELLER_MODAL = 'ADOPT_SELLER_MODAL',
  BUYER_MODAL = 'ADOPT_BUYER_MODAL',
  TRANSACTION_HISTORY_MODAL = 'EXCLUSIVE_TRANSACTION_HISTORY_MODAL',
  ORDER_ORIGINAL_DEVIATION_MODAL = 'ADOPT_ORDER_ORIGINAL_DEVIATION_MODAL',
}
